// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"420":"add5113c","594":"1e8d0706"}[chunkId] + ".js";
};